// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-locations-section[data-v-313b1d2a]{padding-top:50px;margin-bottom:50px}@media(min-width:992px){.restaurant-locations-section[data-v-313b1d2a]{padding-top:90px}}.restaurant-cta-list[data-v-313b1d2a]{max-width:1225px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
